function splitDuration(seconds) {
  const total = Math.floor(Math.max(seconds, 0));
  return {
    hours: Math.floor(total / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
}

// the two largest units of a spent time: "5h 3m", "12m 7s", "42s"
export function durationParts(seconds, t) {
  const { hours, minutes, seconds: secs } = splitDuration(seconds);
  const unit = key => t(`time.${key}`).toLowerCase();
  if (hours) {
    return [{ value: hours, unit: unit('H') }, { value: minutes, unit: unit('M') }];
  }
  if (minutes) {
    return [{ value: minutes, unit: unit('M') }, { value: secs, unit: unit('S') }];
  }
  return [{ value: secs, unit: unit('S') }];
}

// hours and minutes without zero parts: "1h 30m", "45m", "2h"
export function formatHoursMinutes(seconds, t) {
  const { hours, minutes } = splitDuration(seconds);
  const parts = [];
  if (hours) parts.push(`${hours}${t('time.H')}`);
  if (minutes || !hours) parts.push(`${minutes}${t('time.M')}`);
  return parts.join(' ').toLowerCase();
}

// minutes always shown, zero-padded after hours, so the width holds while the value changes: "1h 00m", "1h 05m", "45m"
export function formatHoursPaddedMinutes(seconds, t) {
  const { hours, minutes } = splitDuration(seconds);
  if (!hours) return `${minutes}${t('time.M')}`.toLowerCase();
  return `${hours}${t('time.H')} ${String(minutes).padStart(2, '0')}${t('time.M')}`.toLowerCase();
}

export function formatDuration(seconds, t) {
  return durationParts(seconds, t).map(part => `${part.value}${part.unit}`).join(' ');
}

// "5h 3m 7s" — exact spent time for tooltips
export function formatFullDuration(seconds, t) {
  const { hours, minutes, seconds: secs } = splitDuration(seconds);
  return `${hours}${t('time.H')} ${minutes}${t('time.M')} ${secs}${t('time.S')}`.toLowerCase();
}
